export default __webpack_public_path__ + "static/media/analytics-not-selected.9878c812.svg";